import React from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';
import Logoutbutton from './Logoutbutton';

const MOBILE_BREAKPOINT = 1100;

function Sidebar({ isAdminLoggedIn, isCollapsed, toggleSidebar, handleLogout }) {
  const sidebarClass = !isAdminLoggedIn
      ? 'hide'
      : isCollapsed ? 'collapsed' : 'expanded';

  const handleNavClick = () => {
    if (window.innerWidth <= MOBILE_BREAKPOINT) toggleSidebar();
  };

  return (
      <>
        {isAdminLoggedIn && !isCollapsed && (
            <div className="sidebar-overlay active" onClick={toggleSidebar} />
        )}

        <div className={`sidebar ${sidebarClass}`}>
          <div className="sidebar-header">
            <span className="sidebar-header-title">Admin Panel</span>
            <button type="button" className="sidebar-close-btn" onClick={toggleSidebar} aria-label="Close sidebar">
              <i className="fas fa-times" />
            </button>
          </div>

          <ul>
            <li>
              <Link to="/admin/dashboard" className="admin-links" onClick={handleNavClick}>
                <i className="bx bxs-grid-alt" /><span className="link-text">Dashboard</span>
              </Link>
            </li>
            <li>
              <Link to="/admin/products" className="admin-links" onClick={handleNavClick}>
                <i className="bx bx-shopping-bag" /><span className="link-text">Products</span>
              </Link>
            </li>
            <li>
              <Link to="/admin/categories" className="admin-links" onClick={handleNavClick}>
                <i className="bx bx-category" /><span className="link-text">Categories</span>
              </Link>
            </li>
            <li>
              <Link to="/admin/enquiries" className="admin-links" onClick={handleNavClick}>
                <i className="bx bx-envelope" /><span className="link-text">Enquiries</span>
              </Link>
            </li>
            <li>
              <Link to="/admin/users" className="admin-links" onClick={handleNavClick}>
                <i className="bx bx-user" /><span className="link-text">Users</span>
              </Link>
            </li>
          </ul>

          <div className="sidebar-footer">
            <Logoutbutton handleLogout={handleLogout} />
          </div>
        </div>
      </>
  );
}

export default Sidebar;